import { DragDropContext, Droppable } from "react-beautiful-dnd";
import AssetsTitle from "./AssetsTitle";
import DraggableAsset from "./DraggableAsset";
import { useAssetDragAndDrop } from "./useAssetDragAndDrop";
import type { AssetGroup, AssetsLayout, Household } from "@/types/types";

type Props = {
  assetGroups: AssetGroup[] | undefined;
  isNonAssetBal?: boolean;
  household: Partial<Household> | undefined;
  layout: AssetsLayout;
  total: number;
};

const Assets: React.FC<Props> = ({
  assetGroups,
  household,
  isNonAssetBal = false,
  layout,
  total,
}) => {
  const { leftColumnItems, rightColumnItems, onDragEnd } = useAssetDragAndDrop({
    assetGroups,
    householdExternalCode: household?.externalCode as string,
    layout,
  });

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="rounded-md bg-neutral-500 p-8">
        {!isNonAssetBal && assetGroups && assetGroups.length > 0 ? (
          <AssetsTitle total={total} />
        ) : null}

        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
          <Droppable droppableId="left">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="flex flex-col gap-6"
              >
                {leftColumnItems.map((asset, index) => (
                  <DraggableAsset
                    key={asset.externalCode}
                    asset={asset}
                    index={index}
                    isNonAssetBal={isNonAssetBal}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          <Droppable droppableId="right">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="flex flex-col gap-6"
              >
                {rightColumnItems.map((asset, index) => (
                  <DraggableAsset
                    key={asset.externalCode}
                    asset={asset}
                    index={index}
                    isNonAssetBal={isNonAssetBal}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </div>
    </DragDropContext>
  );
};

export default Assets;
